<template>
    <form data-spec-class="form">
        <div :class="allowOverflow ? 'overflow-visible' : 'overflow-hidden'">
            <div class="py-5 sm:py-6">
                <slot />
            </div>
        </div>
        <div
            v-if="!!$slots.submit"
            class="pt-5 text-right"
        >
            <slot name="submit" />
        </div>
    </form>
</template>

<script setup lang="ts">
interface Props {
    allowOverflow?: boolean;
}

withDefaults(defineProps<Props>(), {
    allowOverflow: false,
});
</script>
